import {
  MediaImporter,
  OnMediaAccepted,
  OnMediaImported,
  useEpisodeSearchPlugin,
  usePodcastSearchPlugin,
  useYoutubeUrlPlugin,
} from '@sparemin/media-import';
import React, { useCallback } from 'react';
import { useConnectedModal } from 'state/modals';
import { MODAL_NAME } from './constants';

export interface PodcastSearchModalContentsProps {
  isMobile?: boolean;
}

const PodcastSearchModalContents: React.FC<PodcastSearchModalContentsProps> = ({
  isMobile,
}) => {
  const {
    params: {
      onEpisodeSelected,
      disableEpisodeSearch,
      onPodcastSelected,
      onYoutubeVideoSelected,
      enableYoutubeUrl,
    },
  } = useConnectedModal({ name: MODAL_NAME });

  const handleMediaImported: OnMediaImported = useCallback(
    (media) => {
      if (media.pluginId === 'episodeSearch') {
        onEpisodeSelected?.(media.payload);
      }
      if (media.pluginId === 'podcastSearch') {
        onPodcastSelected?.(media.payload);
      }
    },
    [onEpisodeSelected, onPodcastSelected],
  );

  const handleMediaAccepted: OnMediaAccepted = useCallback(
    (media) => {
      if (media.pluginId === 'youtubeUrl') {
        onYoutubeVideoSelected?.(media.payload);
      }
    },
    [onYoutubeVideoSelected],
  );

  const podcastSearch = usePodcastSearchPlugin();
  const youtubeUrl = useYoutubeUrlPlugin();
  const episodeSearch = useEpisodeSearchPlugin();

  return (
    <MediaImporter
      layout={isMobile ? 'mobile' : 'desktop'}
      onMediaAccepted={handleMediaAccepted}
      onMediaImported={handleMediaImported}
      plugins={[
        podcastSearch,
        ...(enableYoutubeUrl ? [youtubeUrl] : []),
        ...(disableEpisodeSearch ? [] : [episodeSearch]),
      ]}
    />
  );
};

export default PodcastSearchModalContents;
